module.exports = __webpack_public_path__ + "static/media/icon-x.e62dcaab.png";